import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomerListByEmail } from "../actions/customerListActions";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

export const customerListSlice = createSlice({
  name: "customerList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerListByEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerListByEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data || []; // <-- fix here
      })
      .addCase(fetchCustomerListByEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error;
      });
  }
});

export const selectCustomerList = (state) => state.customerList.list;
export const selectCustomerListLoading = (state) => state.customerList.loading;
export const selectCustomerListError = (state) => state.customerList.error;

export default customerListSlice.reducer;

